import moment from 'moment';
import { currentTime } from 'helpers/time';

// A new job's default times: start 15 minutes from now, rounded up to the next
// `step` minutes (5 for a job; 15 for a service agreement's visits, whose time
// lists go in 15-minute steps); end an hour after the start. (Kept out of
// stores/Job so the job form can use it without importing the stores, which
// would be circular.)
export const newJobTimes = (now = moment(), step = 5) => {
  // Round up from the exact earliest time, seconds included, so the start is
  // never less than 15 minutes ahead (10:00:59 gives 10:20, not 10:15).
  const earliest = moment(now).add(15, 'minutes');
  const start = moment(earliest).seconds(0).milliseconds(0);
  if (start.isBefore(earliest)) start.add(1, 'minute');
  const remainder = start.minutes() % step;
  if (remainder) start.add(step - remainder, 'minutes');
  return { start, end: moment(start).add(1, 'hour') };
};

// The empty job's start time (stores/Job): "now" each time the form is
// cleared, and remembered so the job form can treat a new job still holding it
// as "no time chosen yet". Times set anywhere else aren't marked.
const emptyJobStarts = new WeakSet();

export const emptyJobStart = () => {
  const start = currentTime();
  emptyJobStarts.add(start);
  return start;
};

export const isEmptyJobStart = (value) => !!value && typeof value === 'object' && emptyJobStarts.has(value);
